import PostDetailContainer from "./PostDetailContainer";
export default PostDetailContainer;
